import { eClassesActionTypeDefine } from "../../action-types/classes/IClassesActions";
import { generateActions } from "../generateActions";

export const classesActions = {
    ...generateActions(eClassesActionTypeDefine, "CLASSES"),
};
